"use client";

import { Tooltip } from "antd";
import cn from "classnames";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { memo, ReactNode } from "react";

export const ConsistentHeaderWrapper = ({ children }: { children: ReactNode }) => {
    return <div className={cn("consistent-header-wrapper")}>{children}</div>;
};

export const ConsistentHeader = ({ children }: { children: ReactNode }) => {
    return <header className={cn("consistent-header")}>{children}</header>;
};

export const SiteHeaderLeftWrapper = ({ children }: { children: ReactNode }) => {
    return <div className="site-header-left-wrapper">{children}</div>;
};

export const SiteHeaderRightWrapper = ({ children }: { children: ReactNode }) => {
    return <div className="site-header-right-wrapper">{children}</div>;
};

export const SiteLogoWrapper = ({ children }: { children: ReactNode }) => {
    return <div className="site-logo-wrapper">{children}</div>;
};

export { default as SiteLogo } from "./SiteLogo";

export const SiteLogoTitle = ({ children }: { children: ReactNode }) => {
    return <h1 className="site-logo-title">{children}</h1>;
};

const NavMenuButton = ({
    children,
    href,
    strict,
    cmpString,
}: {
    cmpString?: string;
    strict?: boolean;
    children: ReactNode;
    href: string;
}) => {
    const pathName = usePathname();
    const isActive = strict ? (cmpString ?? href) == pathName : pathName.startsWith(cmpString ?? href);
    return (
        // <Tooltip title={children} placement="top" >
        <Link className={cn("nav-menu-button", { "nav-menu-button-active": isActive })} href={href}>
            {children}
        </Link>
        // </Tooltip>
    );
};

const NavMenuComponent = ({
    options,
}: {
    options: { strict?: boolean; href: string; cmpString?: string; title: string }[];
}) => {
    return (
        <nav className="nav-menu">
            {options.map((item, i) => {
                return (
                    <NavMenuButton strict={item.strict} cmpString={item.cmpString} href={item.href} key={i}>
                        {item.title}
                    </NavMenuButton>
                );
            })}
        </nav>
    );
};

export const NavMenu = memo(NavMenuComponent);

export const Nav = ({ children }: { children: ReactNode }) => {
    return <div className={cn("nav")}>{children}</div>;
};

export const StickyFooter = ({ children }: { children: ReactNode }) => {
    return (
        <>
            <footer className="sticky-footer">{children}</footer>
        </>
    );
};

export const Footer = ({ children }: { children: ReactNode }) => {
    return <div className="footer">{children}</div>;
};

export const LayoutWrapper = ({ children }: { children: ReactNode }) => {
    return <div className="layout-wrapper"> {children} </div>;
};

export const MainWrapper = ({ children }: { children: ReactNode }) => {
    return <main className="main-wrapper"> {children} </main>;
};

export const ContentWrapper = ({ children }: { children: ReactNode }) => {
    return <div className="content-wrapper"> {children} </div>;
};
